import React, { useMemo } from 'react'
import { CaptionProps, useNavigation } from 'react-day-picker'
import { Icon, IconName } from '~components/Icon'
import * as Styled from './Caption.styles'

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

export const Caption: React.FC<CaptionProps> = ({ displayMonth }) => {
  const { goToMonth, nextMonth, previousMonth } = useNavigation()

  const formattedDate = useMemo(() => `${MONTHS[displayMonth.getMonth()]}, ${displayMonth.getFullYear()}`, [displayMonth])

  return (
    <Styled.Container>
      <Styled.IconButton onClick={() => previousMonth && goToMonth(previousMonth)}>
        <Icon name={IconName.chevron_left} size="large" />
      </Styled.IconButton>
      <Styled.Month>{formattedDate}</Styled.Month>
      <Styled.IconButton onClick={() => nextMonth && goToMonth(nextMonth)}>
        <Icon name={IconName.chevron_right} size="large" />
      </Styled.IconButton>
    </Styled.Container>
  )
}
